export const writeEmailHeaderText = "k$a";
export const emailListHeaderText = "l$a";
export const readEmailHeaderText = "m$a";
export const goToHeaderText = "n$a";
export const emailActionsHeaderText = "o$a";
export const goToQuickSwitcher = "p$a";
export const newEmailCommand = "q$a";
export const sendEmailCommand = "r$a";
export const replyEmailCommand = "s$a";
export const replyAllEmailCommand = "t$a";
export const forwardEmailCommand = "u$a";
export const saveDraftCommand = "v$a";
export const discardDraftCommand = "w$a";
export const goToInboxCommand = "x$a";
export const goToDraftsCommand = "y$a";
export const goToSentCommand = "z$a";
export const searchEmailCommand = "A$a";
export const undoCommand = "B$a";
export const clearAllMessagesCommand = "C$a";
export const homeCommand = "D$a";
export const endCommand = "E$a";
export const deleteEmailCommand = "F$a";
export const openEmailCommand = "G$a";
export const openEmailInNewWindowCommand = "H$a";
export const closeEmailCommand = "I$a";
export const openNextItemCommand = "J$a";
export const openPreviousItemCommand = "K$a";
export const focusNextItemPartCommand = "L$a";
export const focusPreviousItemPartCommand = "M$a";
export const expandCollapseConversationCommand = "N$a";
export const expandConversationCommand = "O$a";
export const collapseConversationCommand = "P$a";
export const softDeleteCommand = "Q$a";
export const newFolderCommand = "R$a";
export const markReadCommand = "S$a";
export const markUnreadCommand = "T$a";
export const flagEmailCommand = "U$a";
export const archiveCommand = "V$a";
export const markJunkCommand = "W$a";
export const categorize = "X$a";
export const insertHyperlinkCommand = "Y$a";
export const showKeyboardShortcutsCommand = "Z$a";
export const toggleSelectMessageCommand = "_$a";
export const quickStepCommand = "$$a";
export default {writeEmailHeaderText,emailListHeaderText,readEmailHeaderText,goToHeaderText,emailActionsHeaderText,goToQuickSwitcher,newEmailCommand,sendEmailCommand,replyEmailCommand,replyAllEmailCommand,forwardEmailCommand,saveDraftCommand,discardDraftCommand,goToInboxCommand,goToDraftsCommand,goToSentCommand,searchEmailCommand,undoCommand,clearAllMessagesCommand,homeCommand,endCommand,deleteEmailCommand,openEmailCommand,openEmailInNewWindowCommand,closeEmailCommand,openNextItemCommand,openPreviousItemCommand,focusNextItemPartCommand,focusPreviousItemPartCommand,expandCollapseConversationCommand,expandConversationCommand,collapseConversationCommand,softDeleteCommand,newFolderCommand,markReadCommand,markUnreadCommand,flagEmailCommand,archiveCommand,markJunkCommand,categorize,insertHyperlinkCommand,showKeyboardShortcutsCommand,toggleSelectMessageCommand,quickStepCommand};